function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{opacity:0.3;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#F0F0F0;}\n\t.st4{fill:#A7A7A7;}\n\t.st5{fill:#606060;}\n\t.st6{fill:#CACACA;}\n\t.st7{fill:#B2B2B2;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#666666;}\n\t.st10{fill:#AAAAAA;}\n\t.st11{fill:#383A45;}\n\t.st12{fill:#BFBFBF;}\n\t.st13{fill:#C0C0C0;}\n\t.st14{fill:#686868;}\n\t.st15{fill:#8A8A8A;}\n\t.st16{fill:#C3C3C3;}\n\t.st17{fill:#FC8B4C !important;}\n\t.st18{fill:#FFC9AD;}\n\t.st19{fill:#FBFBFB;}\n\t.st20{fill:#969696;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12,0h304c6.6,0,12,5.4,12,12v56c0,6.6-5.4,12-12,12H12C5.4,80,0,74.6,0,68V12C0,5.3,5.4,0,12,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M195.1,0H316c6.6,0,12,5.4,12,12v56c0,6.6-5.4,12-12,12H195.1V0z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M216.4,38.6c0,0,53.1-47.1,77.4-29.5c24.3,17.6,4.4,36.5,14.9,36.9c10.6,0.4,31.8-18.9,41.1,1.8 c9.3,20.7-28.9,45.6-22.1,46.7c6.8,1.1,18.3-2.7,18.3,5.1c0,7.8-32.5,38.6-54.5,36.5c-22-2.1,9.8-23.2-3.1-21.3 c-12.9,1.9-34.8,31.5-52.2,13.5c-17.4-18,15.3-51.2,0.8-46.5C213.1,89.5,184.9,69,216.4,38.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M283.7,39.4c3.5-2.2,1.9-7.5-1.6-9.4c-3.4-1.9-1.7-2.6-1.6-6.9c0.3-7.2-4.1-7.5-4.1-7.5s-4.1-0.2-4.1,7.5 c0,4.3,1.8,5-1.6,6.9c-3.4,1.9-5.1,7.2-1.6,9.4c4.2,2.6-4.7,3.9-3.2,11.3c1,5,6.5,4.9,10.5,5c4-0.1,9.4,0,10.5-5 C288.5,43.3,279.5,42,283.7,39.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M276.4,54.1c0.1-0.3,0.5-23.1,0-27.4C276.2,25.2,275.6,56.9,276.4,54.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M271.8,32.2c0,0,3.9,5.8,4.5,5.7c0.6-0.1,4.8-5.5,4.4-5.8c-0.1-0.1-4.4,5.2-4.4,5.2S271.5,31.2,271.8,32.2z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M271.8,37.7c0,0,3.9,5.8,4.5,5.7c0.6-0.1,4.8-5.5,4.4-5.8c-0.1-0.1-4.4,5.2-4.4,5.2S271.5,36.6,271.8,37.7z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M271.8,44.5c0,0,3.9,5.8,4.5,5.7c0.6-0.1,4.8-5.5,4.4-5.8c-0.1-0.1-4.4,5.2-4.4,5.2S271.5,43.5,271.8,44.5z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M304,59.3v-8.7H250v8.7c-10.7,0-19.4,8.6-19.4,19.3s8.7,19.3,19.4,19.3c0.9,0,1.9-0.1,2.8-0.2 c3.8,7.6,11.2,13.1,19.9,14.5v21.6h-7.6c-3.9,0-7.1,3.2-7.1,7h14.6v0.2h8.6v-0.2h14.6c0-3.9-3.2-7-7.1-7h-7.6v-21.6 c8.7-1.4,16.1-6.9,19.9-14.5c0.9,0.1,1.9,0.2,2.9,0.2c10.7,0,19.4-8.6,19.4-19.3C323.4,67.9,314.7,59.3,304,59.3z M250,92 c-7.4,0-13.5-6-13.5-13.4c0-7.4,6-13.4,13.5-13.4v18.3c-0.1,0.7-0.1,1.4-0.1,2.1c0,2.2,0.3,4.4,0.8,6.4 C250.4,92,250.2,92,250,92z M304,92c-0.3,0-0.5,0-0.8,0c0.5-2.1,0.8-4.2,0.8-6.4V65.2c7.4,0,13.5,6,13.5,13.4 C317.5,86,311.5,92,304,92z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M258.5,67.7c0-6.2,1.6-12.1,4.5-17.1h-13v8.7c-10.7,0-19.4,8.6-19.4,19.3s8.7,19.3,19.4,19.3 c0.9,0,1.9-0.1,2.8-0.2c3.8,7.6,11.2,13.1,19.9,14.5v21.6h-7.6c-3.9,0-7.1,3.2-7.1,7h14.6v0.2h8.6v-0.2h14.6c0-3.9-3.2-7-7.1-7 h-7.6v-21.6c6.7-1.1,12.6-4.6,16.7-9.6c-1.4,0.2-2.7,0.2-4.1,0.2C274.3,102.8,258.5,87.1,258.5,67.7z M250,92 c-7.4,0-13.5-6-13.5-13.4c0-7.4,6-13.4,13.5-13.4v18.3c-0.1,0.7-0.1,1.4-0.1,2.1c0,2.2,0.3,4.4,0.8,6.4 C250.4,92,250.2,92,250,92z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M246.3,56.9l-10.6,14.3c-2.1,2.8-0.1,6.7,3.4,6.7h21.2c3.5,0,5.5-3.9,3.4-6.7l-10.6-14.3 C251.4,54.7,248,54.7,246.3,56.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M252.7,36.6h-5.9v26.7h5.9V36.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M252.4,35.9h-5.3c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h5.3c1,0,1.8-0.8,1.8-1.8 C254.2,36.7,253.4,35.9,252.4,35.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M260.2,71l-4.4-6h-12.1l-4.4,6c-1.6,2.1-0.1,5,2.6,5h15.9C260.3,76,261.8,73.1,260.2,71z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M212.9,100c3.5-2.2,1.9-7.5-1.6-9.4c-3.4-1.9-1.7-2.6-1.6-6.9c0.3-7.2-4.1-7.5-4.1-7.5s-4.1-0.2-4.1,7.5 c0,4.3,1.8,5-1.6,6.9c-3.4,1.9-5.1,7.2-1.6,9.4c4.2,2.6-4.7,3.9-3.2,11.3c1,5,6.5,4.9,10.5,5c4-0.1,9.4,0,10.5-5 C217.7,103.9,208.7,102.6,212.9,100z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M344.8,96.4c3.5-2.2,1.9-7.5-1.6-9.4c-3.4-1.9-1.7-2.6-1.6-6.9c0.3-7.2-4.1-7.5-4.1-7.5s-4.1-0.2-4.1,7.5 c0,4.3,1.8,5-1.6,6.9c-3.4,1.9-5.1,7.2-1.6,9.4c4.2,2.6-4.7,3.9-3.2,11.3c1,5,6.5,4.9,10.5,5c4-0.1,9.4,0,10.5-5 C349.6,100.4,340.6,99.1,344.8,96.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M227,47.3c0,0-7.5,3.6-13.5,1.1c-6-2.5-6.7-2.4-7.6-2c-0.9,0.4,1.4-2.2,6,0c1.4,0.7,8.9,0.7,14.6-3.3 C226.5,43,228.3,46.2,227,47.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M240.6,26.7c0,0,1-0.7,1.7-0.5c0.7,0.1,0.9-0.7,0.9-0.7s0.2,0.9-0.9,1.2c-1,0.3-1.8,0.1-1.7,2.2 c0.1,2.1,4.6,14.1-5,16.8c0,0-1.8-3.3-1.6-4.1c0.3-0.8,4.5-2.9,4.6-6.5C238.7,31.5,238.9,27.2,240.6,26.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M224.3,56.4c0,0-2,4.8-7.1,5.4c-5.2,0.6-9.2-4.9-9.2-4.9l-1.9,1.2c0,0,2.5,6.5,9.3,8 c6.8,1.5,11.6-3.6,11.6-3.6s1.4,0.8,0.9,6.6c-0.7,7.3-1.4,11.6-1.4,11.6h2.3c0,0,3.3-7.8,3.8-13.3c0.6-6.5-0.5-9.8-0.5-9.8 L224.3,56.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M208,57.4l-1.1-1.3c-0.2,0.2-2.6,2-2.6,2.2c0.1,0.2,2.2-0.9,2.2-0.9s0.4,0.6,0.5,0.7 C207.1,58.1,208,57.4,208,57.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M223.2,58.3c0,0,3-7.6,3-13.6c0-4.4,9-3.5,9.3-1.6c0.7,4.4-2.5,18.7-2.5,18.7L223.2,58.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M232.4,41.6c0,0,3.6-2.1,3.8-2.2c0.2-0.1,3.8,3.6,3.8,3.6s-3.3,3.4-5.1,3.6 C233.1,46.8,231.6,41.8,232.4,41.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M220.9,45.1c0,0,0.3,3.8,0.6,4c0.3,0.2,5.7-1,6.1-1.5c0.4-0.5,1-5.7,0.8-5.5S221.3,44.9,220.9,45.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M230.8,37.6c0,0,0-1-0.5-0.9c-0.5,0.1-0.8,1.1-0.6,1.5C230,38.6,230.8,38.5,230.8,37.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M234.1,36.4c0,0,1,2.9-0.7,3.4c-1.7,0.5-1.4-1.4-1.4-1c0.1,0.3,0.5,3.2,0.5,3.2s-0.9,1.1-2.6,0.1 c-0.3-0.2,0.7-4.6,0.9-6.9C230.9,34.3,233.5,35.3,234.1,36.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M231,34.4c0,0,0.4-1.4,1.2-1c0.8,0.3,0.7,0.8,1.3,0.5c0.6-0.3,1.2,0.7,0.9,1.3c-0.4,0.8-0.4,1-1.6,0.8 c-1.2-0.3-1.8-0.7-2-0.2s0.2,1.6-0.1,1.8c-0.3,0.1-0.3-0.8-0.6-0.4c-0.3,0.3-0.7,1.2,0,1.1c0.7-0.1,0.2,0.8-0.1,0.8 c-0.3,0-1.5-1-1.3-2.3c0.1-0.8,1-0.4,0.7-1C229.3,35,229.8,33.7,231,34.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M321,72.1l-5.1-3.4c-1.4-1-1.8-2.9-0.9-4.4l6-9c1-1.4,2.9-1.8,4.4-0.9l5.1,3.4c1.4,1,1.8,2.9,0.9,4.4l-6,9 C324.4,72.6,322.5,73,321,72.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M304.7,102.2l-10.4-6.9c-0.9-0.6-1.1-1.7-0.5-2.6l22.6-33.8c0.6-0.9,1.8-1.1,2.6-0.5l10.4,6.9 c0.9,0.6,1.1,1.7,0.5,2.6l-22.6,33.8C306.7,102.5,305.6,102.8,304.7,102.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M256,31.5c1.7,0,3-1.4,3-3c0-1.7-1.4-3-3-3c-1.7,0-3,1.4-3,3C253,30.2,254.4,31.5,256,31.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M260.2,24.5c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8 C256.4,22.8,258.1,24.5,260.2,24.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M237.3,16.1c4.8,0,8.7-3.9,8.7-8.7c0-4.8-3.9-8.7-8.7-8.7c-4.8,0-8.7,3.9-8.7,8.7 C228.6,12.2,232.5,16.1,237.3,16.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M239.6,20.1l-2.3-12.7L228.7,9c0,0,0.7,4.2,4.2,6.3c2.6,1.6,3.3,5.4,3.3,5.4L239.6,20.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M239.5,20.1l-2.3-12.7l8.6-1.5c0,0,0.8,4.2-1.8,7.4c-1.9,2.4-1.2,6.2-1.2,6.2L239.5,20.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M237.1,20.7c-0.1,0-0.2,0-0.2-0.1l-1.6-9c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1c0.5,1,1.2,1.8,1.4,1.8 c0,0,0-0.1,0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.5-0.4-1.5-0.1-1.7c0.1-0.1,0.2,0,0.3,0c0.2,0.2,0.3,1.1,0.3,1.8 c0.1,0.2,0.3,0.2,0.4,0.1c0.1,0,0.2-0.1,0.3-0.3c-0.2-0.2-0.4-0.6-0.5-0.9c-0.1-0.3-0.1-0.8,0.1-0.9c0.1-0.1,0.2-0.1,0.3,0 c0.3,0.2,0.5,0.9,0.5,1.5c0,0,0,0.1,0,0.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c-0.3-0.4-0.5-1-0.5-1.4 c0-0.3,0.2-0.4,0.2-0.4c0.1-0.1,0.3,0,0.4,0.1c0.3,0.3,0.4,1.1,0.2,1.7c0.1,0.1,0.1,0.2,0.2,0.2c0.1-0.2,0.3-1.2,0.3-2.1 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1l1.5,8.4c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1l-1.3-7.1 c-0.1,0.5-0.2,1-0.4,1.1c0,0-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3,0-0.4-0.1 c-0.1,0.2-0.3,0.4-0.5,0.4c-0.2,0.1-0.5,0.1-0.7-0.1c-0.1,0.2-0.2,0.3-0.3,0.3c-0.4,0-0.8-0.6-1.2-1.1l1.4,8.1 C237.3,20.6,237.2,20.7,237.1,20.7z M238.1,11.3c0,0.1,0,0.3,0.1,0.6c0,0.1,0.1,0.3,0.2,0.4C238.3,11.9,238.2,11.5,238.1,11.3z  M239.1,11.1c0,0,0,0.1,0,0.2c0,0.2,0.1,0.5,0.3,0.7C239.4,11.6,239.2,11.1,239.1,11.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M243.9,6.7C243.9,6.8,243.8,6.8,243.9,6.7c-0.5,0-0.8-0.3-0.9-0.8c-0.4-3.8-3.1-4-3.2-4.1 c-0.4,0-0.7-0.4-0.7-0.9c0-0.5,0.4-0.8,0.8-0.8c1.4,0.1,4.2,1.5,4.6,5.6C244.5,6.3,244.3,6.7,243.9,6.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M242.8,18.5l-6.7,1.2l1,5.6l6.7-1.2L242.8,18.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M242.3,21.7l-4.9,0.9l0.7,3.9l4.9-0.9L242.3,21.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M237.8,1.4c0.4,0,0.8-0.4,0.8-0.8c0-0.4-0.4-0.8-0.8-0.8S237,0.1,237,0.6C237,1,237.4,1.4,237.8,1.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M313.1,49l0.2,1.7c0.3,0,3.3-0.1,3.4-0.3c0-0.2-2.3-0.5-2.3-0.5s0-0.7,0-0.8C314.3,49,313.1,49,313.1,49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M306.9,63.4l-0.4,1.7c0.3,0.1,3.2,0.9,3.3,0.7c0.1-0.2-2.1-1.2-2.1-1.2s0.2-0.7,0.2-0.8 C308,63.7,306.9,63.4,306.9,63.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M301.5,42c0,0,4.5-8.7,9.7-8.1c5.2,0.6,3.7,15.3,3.7,15.3h-2c0,0-0.4-10.8-2.2-10.8s-7.7,8.3-7.7,8.3 s7.7-0.7,8.8,4.6c1.3,6.4-3.1,12.9-3.1,12.9l-2.5-0.1c0,0,4.8-11.1,2.1-12.7c-4.1-2.5-12.1,2-15.2-3.9L301.5,42z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M295.7,30.3c0,0,5.6,2.1,8.5,0.9c2.9-1.2,6.1-7.1,8-7.2c1.8-0.1,1.9-0.7,1.9-0.7s-0.1,1.6-1.3,1.7 c-1.2,0.1-2.6,6.9-7.2,8.7c-4.6,1.8-9.4,0.4-9.4,0.4S295.1,31.1,295.7,30.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M298.2,30.1c0,0-9.7-3.6-5.3,17.4c0,0,10.1-3.2,8.6-5.5c-1.1-1.6-1.5-0.5-1.7-3.1 C299.6,36.4,305.4,36.1,298.2,30.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M294,21.9c0-0.1,1.7-2.7,4.4-1c1.1,0.7,1.2,2,2.6,2.4c1.4,0.3,3.4-1,4.2,1.3c0.7,2.3-0.1,2.9,1.1,3.2 c1.3,0.3,2.2,0.1,1.9,1.9c-0.4,2.5-4.4,2.6-4.8,1.2c-1.2-3.7-3.3,0.7-4.3-2.6C298.5,26.6,291.5,29.2,294,21.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M297.3,25.5c0,0,0.5-0.9,1-0.8c0.5,0.1,0.4,1,0.1,1.4C298.2,26.5,297.3,26.4,297.3,25.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M293.8,24c0,0-0.7,3.2,1,3.7c1.7,0.5,1.4-1.4,1.4-1c-0.1,0.3-0.5,3.2-0.5,3.2s0.9,1.1,2.6,0.1 c0.3-0.2-0.7-4.6-0.9-6.9C297.2,22.2,294.4,22,293.8,24z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M296.8,33.8c0,0,5.4,2.7,8.4,1.9c3-0.9,6.9-6.4,8.7-6.2c1.8,0.1,2-0.5,2-0.5s-0.3,1.6-1.5,1.5 c-1.2-0.1-3.4,6.5-8.2,7.8c-4.8,1.3-9.4-0.7-9.4-0.7S296,34.5,296.8,33.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M298.2,30.1c0,0,2.5,1.4,2.8,1.5c0.4,0,0,2.5,0,2.5S297.6,32.4,298.2,30.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M296,32.9c0,0,3.3,1.3,3.5,1.7c0.2,0.5-0.4,4.3-1.2,4.1c-0.9-0.2-3.8-0.7-3.9-2.6 C294.3,34.1,294.9,32.4,296,32.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M314.1,29.8c4.6,0,8.2-3.7,8.2-8.2s-3.7-8.2-8.2-8.2c-4.6,0-8.2,3.7-8.2,8.2S309.5,29.8,314.1,29.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M311.6,21.6c0,0.1,0,0.2,0,0.4h2.3v-0.4H311.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M314.3,21.6V22h2.3c0-0.1,0-0.2,0-0.4H314.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M322.3,22c0-0.1,0-0.2,0-0.4v0H317c0,0.1,0,0.2,0,0.4H322.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M305.9,21.6L305.9,21.6c0,0.1,0,0.2,0,0.4h5.3c0-0.1,0-0.2,0-0.4H305.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M314.3,13.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0v8.2V22v7.8c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0V22 v-0.4V13.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M317,22.1C317,22.1,317,22,317,22.1c0-0.2,0-0.3,0-0.5c0.1-2.6,1-4.9,2.3-6.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-1.4,1.5-2.3,3.9-2.4,6.5c0,0.1,0,0.2,0,0.4c0,0,0,0.1,0,0.1c0,2.5,0.8,4.8,2,6.4c0.1-0.1,0.2-0.1,0.3-0.2 C317.7,26.8,317,24.5,317,22.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M309.1,15.1c-0.1,0.1-0.2,0.1-0.3,0.2c1.3,1.5,2.2,3.7,2.3,6.3c0,0.1,0,0.2,0,0.4c0,0,0,0.1,0,0.1 c0,2.5-0.7,4.7-1.9,6.2c0.1,0.1,0.2,0.1,0.3,0.2c1.2-1.6,2-3.9,2-6.4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4 C311.5,19,310.5,16.6,309.1,15.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M247.8,0.7c-0.1-0.3-0.4-0.4-0.7-0.3L246,0.9c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l1.2-0.5 C247.8,1.3,247.9,1,247.8,0.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M249.5,3.5c0-0.3-0.3-0.5-0.6-0.4l-1.3,0.2c-0.3,0-0.5,0.3-0.4,0.6s0.3,0.5,0.6,0.4l1.3-0.2 C249.3,4,249.5,3.8,249.5,3.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M250.1,6.8c0-0.3-0.2-0.5-0.5-0.5l-1.3,0c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5l1.3,0 C249.8,7.3,250.1,7.1,250.1,6.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M249.8,9.9c0.1-0.3-0.1-0.5-0.4-0.6L248.2,9c-0.3-0.1-0.5,0.1-0.6,0.4c-0.1,0.3,0.1,0.5,0.4,0.6l1.2,0.3 C249.5,10.3,249.8,10.2,249.8,9.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M249.1,13.1c0.1-0.2,0-0.5-0.2-0.7l-1.1-0.6c-0.2-0.1-0.6,0-0.7,0.2c-0.1,0.2,0,0.5,0.2,0.7l1.1,0.6 C248.6,13.4,248.9,13.3,249.1,13.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M247,15.2c0.2-0.2,0.3-0.5,0.1-0.7l-0.7-1.1c-0.2-0.2-0.5-0.3-0.7-0.1c-0.2,0.2-0.3,0.5-0.1,0.7l0.7,1.1 C246.4,15.3,246.8,15.4,247,15.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M226.9,1c0.1-0.2,0.4-0.3,0.7-0.2l1.1,0.6c0.2,0.1,0.3,0.4,0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.2l-1.1-0.6 C226.8,1.5,226.8,1.2,226.9,1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M225.6,4.6c0-0.3,0.3-0.5,0.5-0.5l1.3,0.1c0.3,0,0.5,0.3,0.5,0.5c0,0.3-0.3,0.5-0.5,0.5l-1.3-0.1 C225.8,5.1,225.6,4.9,225.6,4.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M225,7.8c-0.1-0.3,0.1-0.5,0.4-0.6l1.3-0.3c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6l-1.3,0.3 C225.3,8.3,225.1,8.1,225,7.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M225.6,11.1c-0.1-0.3,0.1-0.5,0.3-0.6l1.2-0.4c0.3-0.1,0.6,0.1,0.6,0.3c0.1,0.3-0.1,0.5-0.3,0.6l-1.2,0.4 C226,11.5,225.7,11.4,225.6,11.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M226.9,14c-0.2-0.2-0.1-0.5,0.1-0.7l1.1-0.7c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-1.1,0.7 C227.3,14.2,227,14.2,226.9,14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M228.7,16.7c-0.2-0.2-0.2-0.5-0.1-0.7l0.8-1c0.2-0.2,0.5-0.2,0.7-0.1c0.2,0.2,0.2,0.5,0.1,0.7l-0.8,1 C229.2,16.8,228.9,16.8,228.7,16.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M231.4,18c-0.3-0.1-0.4-0.3-0.4-0.6l0.3-1.2c0.1-0.3,0.3-0.4,0.6-0.4c0.3,0.1,0.4,0.3,0.4,0.6l-0.3,1.2 C231.9,17.9,231.6,18,231.4,18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M291,87.2c0,0,2.2-15.5,0-17.7c-3.4-3.4-9.3-0.9-9.5-0.5c-1,1.6-1.1,17.7-1.1,17.7L291,87.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M288.9,68.2l-0.3,28.2h2.8c0,0,1-25.2,0.6-26.6C291.6,68.4,288.9,68.2,288.9,68.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M276.4,93l1.6,1.2c0,0,4.9-6.9,4.7-7.7c-0.1-0.8,0.7-18.3,0.7-18.3s-1.8,0.1-2.1,1.4 c-1.1,4-0.9,16.3-0.9,16.3S277.9,89.9,276.4,93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M286.6,63.3c0,0,0-1,0.5-0.9c0.5,0.1,0.8,1.1,0.6,1.5C287.4,64.2,286.6,64.1,286.6,63.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.3,62c0,0-1,2.9,0.7,3.4c1.7,0.5,1.4-1.4,1.4-1c-0.1,0.3-0.4,3.7-0.4,3.7s0.8,0.7,2.4-0.3 c0,0-0.7-4.6-0.9-6.9C286.5,59.9,283.9,60.9,283.3,62z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M286.4,60c0,0-0.4-1.4-1.2-1c-0.8,0.3-0.7,0.8-1.3,0.5c-0.6-0.3-1.2,0.7-0.9,1.3c0.4,0.8,0.4,1,1.6,0.8 c1.2-0.3,1.8-0.7,2-0.2c0.3,0.5-0.2,1.6,0.1,1.8c0.3,0.1,0.3-0.8,0.6-0.4c0.3,0.3,0.7,1.2,0,1.1c-0.7-0.1-0.2,0.8,0.1,0.8 c0.3,0,1.5-1,1.3-2.3c-0.1-0.8-1-0.4-0.7-1C288.1,60.6,287.6,59.4,286.4,60z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M292.1,87.2c0,0-1.5-1.1,0.5-3.2c1.7-1.8,5.7-6.1,4.3-7.7c-1.4-1.6-4.8-2.8-4.8-2.8l-0.7-4.5 c0,0,7.5,2.9,9,7c1.4,3.9-6.8,8.5-7.4,9.1C292,85.9,292.1,87.2,292.1,87.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M281.5,69c0,0-7.9,2.5-8.2,8c-0.4,5.5,7.2,7.5,6.7,8.5c-0.4,0.8-1.7,1-1.3,1c0.4-0.1,2.4,0.7,1.8-1.9 c-0.6-2.6-6.3-4.5-3.7-7.9c1.4-1.8,4.1-2.8,4.1-2.8S281.1,70.2,281.5,69z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M291.6,73.9l3.6,1.3c0,0,2.2-2.7,2.1-2.8c-0.1-0.1-3.8-3.3-7.7-4.1C289.7,68.3,290.7,73.1,291.6,73.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M282,73.9c0,0-2.7,0.8-3.9,2c0,0-2.8-3-2.8-3c0.1-0.1,2.6-3,7.5-4.5L282,73.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M282.9,64.4c0,0,0.5-0.4,1.2,0c0.6,0.4,2.4-0.2,2.4-1.4l0.5-0.3c0,0-0.4,3.2-2.2,3.5 C282.9,66.3,282.6,64.5,282.9,64.4z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M272,8h37c5.5,0,10,4.5,10,10l0,0c0,5.5-4.5,10-10,10h-37c-5.5,0-10-4.5-10-10l0,0C262,12.4,266.5,8,272,8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M272.1,15.6v-1h2V21h-1.1v-5.4H272.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M275.2,17.7c0,1,0.2,1.8,0.5,2.4c0.4,0.6,1,0.9,1.8,0.9s1.4-0.3,1.8-0.9c0.4-0.6,0.5-1.4,0.5-2.4 c0-1-0.2-1.8-0.5-2.4c-0.4-0.6-1-0.9-1.8-0.9s-1.4,0.3-1.8,0.9C275.4,16,275.2,16.7,275.2,17.7z M278.9,17.7c0,0.7-0.1,1.3-0.3,1.7 c-0.2,0.4-0.5,0.6-1,0.6c-0.5,0-0.9-0.2-1.1-0.6c-0.2-0.4-0.3-1-0.3-1.7c0-0.7,0.1-1.3,0.3-1.7c0.2-0.4,0.5-0.6,1.1-0.6 c0.5,0,0.9,0.2,1,0.6C278.8,16.5,278.9,17,278.9,17.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M284.1,18.5V21h-1v-6.4h2.2c0.7,0,1.3,0.2,1.6,0.5c0.4,0.3,0.6,0.8,0.6,1.4c0,0.6-0.2,1.1-0.6,1.4 c-0.4,0.3-0.9,0.5-1.6,0.5H284.1z M285.1,17.7c0.8,0,1.3-0.4,1.3-1.1c0-0.4-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-1-0.3h-1v2.2H285.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M290.6,15.9c0.5,0,0.9,0.1,1.3,0.3s0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.4c0,0.5-0.1,1-0.3,1.4 s-0.5,0.7-0.9,0.9s-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.3-0.8-0.3-1.4 c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-0.9C289.7,16.1,290.1,15.9,290.6,15.9z M290.6,16.8c-0.3,0-0.5,0.1-0.7,0.2 c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.2-0.2,0.5-0.2,0.9c0,0.4,0.1,0.7,0.2,0.9c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.1,0.5,0.2,0.7,0.2 s0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.6,0.2-0.9c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.3-0.3-0.4-0.5-0.6 C291.1,16.9,290.9,16.8,290.6,16.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M294,14.6c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4 s-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2S294,14.7,294,14.6z M295.2,16v5h-1v-5H295.2z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M299.2,15.9c0.6,0,1,0.2,1.4,0.6c0.3,0.4,0.5,0.9,0.5,1.6V21h-1v-2.8c0-0.4-0.1-0.8-0.3-1 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-1,0.4c-0.2,0.3-0.4,0.6-0.4,1.1V21h-1v-5h1v1.1c0.1-0.4,0.4-0.7,0.7-0.9 C298.4,16,298.8,15.9,299.2,15.9z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M304.8,20.1V21h-0.6c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.4-0.7-0.4-1.3v-2.4h-0.7V16h0.7v-1.2h1V16h1.2v0.9 h-1.2v2.4c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.6,0.2H304.8z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M307.4,15.9c0.6,0,1,0.2,1.4,0.5c0.4,0.3,0.6,0.7,0.6,1.2h-1c0-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.3-0.7-0.3 c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.4,0.1,0.7,0.2 c0.4,0.1,0.7,0.2,0.9,0.3c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.5,0.3,0.8c0,0.4-0.2,0.8-0.5,1c-0.3,0.3-0.7,0.4-1.3,0.4 c-0.6,0-1.1-0.1-1.5-0.4c-0.4-0.3-0.6-0.7-0.7-1.2h1c0,0.3,0.1,0.5,0.4,0.7c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.4s-0.2-0.2-0.4-0.2c-0.2-0.1-0.4-0.1-0.7-0.2c-0.4-0.1-0.7-0.2-0.9-0.3 c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.2-0.5-0.2-0.8c0-0.4,0.2-0.8,0.5-1C306.4,16.1,306.8,15.9,307.4,15.9z"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 28,
  cy: 40,
  r: 12
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M31,37.1l-4.3,4.4L25,39.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.4,0.2c-0.2,0.2-0.2,0.6,0,0.8l2.1,2.2 c0.2,0.2,0.6,0.2,0.8,0l4.7-4.8c0.2-0.2,0.2-0.6,0-0.8C31.6,36.9,31.2,36.9,31,37.1z"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "st19",
  cx: 28,
  cy: 40,
  r: 12
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M25.4,43.3c1.1-0.8,2-1.5,2.7-2.3c0.7-0.8,1-1.5,1-2.1c0-0.4-0.1-0.7-0.3-1c-0.2-0.2-0.5-0.4-1-0.4 c-0.5,0-0.8,0.2-1.1,0.5c-0.2,0.3-0.4,0.7-0.4,1.2h-0.9c0-0.8,0.3-1.4,0.7-1.8c0.4-0.4,1-0.6,1.7-0.6c0.7,0,1.2,0.2,1.6,0.5 c0.4,0.4,0.6,0.9,0.6,1.5c0,0.5-0.2,1.1-0.5,1.6c-0.3,0.5-0.8,1.1-1.3,1.5c-0.5,0.5-1,0.9-1.6,1.2h3.6v0.8h-4.9V43.3z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M52.6,24.4c1.1,0,1.9,0.3,2.6,0.8c0.7,0.5,1.2,1.3,1.4,2.2h-1.8c-0.2-0.5-0.5-0.8-0.9-1.1c-0.4-0.3-0.8-0.4-1.4-0.4 c-0.4,0-0.9,0.1-1.2,0.3c-0.4,0.2-0.6,0.5-0.8,1s-0.3,0.9-0.3,1.5c0,0.6,0.1,1,0.3,1.5c0.2,0.4,0.5,0.7,0.8,1 c0.4,0.2,0.8,0.3,1.2,0.3c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.6,0.9-1.1h1.8c-0.2,0.9-0.7,1.7-1.4,2.2S53.7,33,52.6,33 c-0.8,0-1.5-0.2-2.1-0.5c-0.6-0.4-1.1-0.9-1.4-1.5c-0.3-0.7-0.5-1.4-0.5-2.2c0-0.8,0.2-1.6,0.5-2.2c0.3-0.7,0.8-1.2,1.4-1.5 C51.1,24.6,51.8,24.4,52.6,24.4z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9,26.2c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.3-0.4,1.8 c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1.1,0.4-1.7,0.4s-1.2-0.1-1.8-0.4c-0.5-0.3-0.9-0.7-1.2-1.2c-0.3-0.5-0.4-1.1-0.4-1.8 c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2C59.7,26.4,60.3,26.2,60.9,26.2z M60.9,27.7c-0.5,0-0.9,0.2-1.2,0.5 c-0.3,0.3-0.5,0.8-0.5,1.4s0.2,1.1,0.5,1.5c0.3,0.3,0.7,0.5,1.2,0.5s0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.8,0.5-1.5s-0.2-1.1-0.5-1.4 C61.8,27.9,61.4,27.7,60.9,27.7z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M74,26.2c0.8,0,1.4,0.3,1.9,0.8c0.5,0.5,0.7,1.2,0.7,2.1V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4 c-0.5,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.3V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.1,0.4 s-0.4,0.7-0.4,1.3V33h-1.7v-6.6h1.7v1.3c0.2-0.4,0.5-0.8,0.8-1c0.4-0.2,0.8-0.4,1.3-0.4c0.5,0,1,0.1,1.4,0.4 c0.4,0.3,0.7,0.6,0.9,1.1c0.2-0.5,0.5-0.8,0.9-1.1C73,26.4,73.5,26.2,74,26.2z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1,26.2c0.6,0,1.1,0.1,1.5,0.4c0.4,0.3,0.8,0.7,1,1.2c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.3-0.4,1.8 c-0.2,0.5-0.6,0.9-1,1.2c-0.4,0.3-1,0.4-1.5,0.4s-1-0.1-1.4-0.4c-0.4-0.3-0.7-0.6-0.8-1.1v4.6h-1.7v-9.8h1.7v1.4 c0.2-0.4,0.4-0.8,0.8-1.1C81,26.4,81.5,26.2,82.1,26.2z M81.6,27.7c-0.5,0-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.4 c0,0.6,0.2,1.1,0.5,1.4c0.3,0.3,0.8,0.5,1.3,0.5c0.5,0,1-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.4s-0.2-1.1-0.5-1.4 S82.1,27.7,81.6,27.7z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M87.9,24.1V33h-1.7v-8.9H87.9z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7,29.4c0,0.2,0,0.4-0.1,0.6h-4.9c0,0.6,0.2,1,0.5,1.3c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,1-0.3 c0.3-0.2,0.4-0.5,0.5-0.8h1.8c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.5,0.3c-0.6,0-1.2-0.1-1.7-0.4 c-0.5-0.3-0.9-0.7-1.2-1.2s-0.4-1.1-0.4-1.8c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2c0.5-0.3,1.1-0.4,1.7-0.4 c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.1,1.1C95.6,28.2,95.7,28.8,95.7,29.4z M94,29.2c0-0.5-0.1-1-0.4-1.2 c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.2,0.4c-0.3,0.3-0.5,0.7-0.5,1.2H94z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M100.4,31.5V33h-0.9c-0.7,0-1.3-0.2-1.7-0.5c-0.4-0.4-0.6-1-0.6-1.8v-2.9h-0.9v-1.4h0.9v-1.6h1.7v1.6h1.5v1.4h-1.5v2.9 c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2H100.4z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M107.9,29.4c0,0.2,0,0.4-0.1,0.6H103c0,0.6,0.2,1,0.5,1.3c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,1-0.3 c0.3-0.2,0.4-0.5,0.5-0.8h1.8c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.5,0.3c-0.6,0-1.2-0.1-1.7-0.4 c-0.5-0.3-0.9-0.7-1.2-1.2s-0.4-1.1-0.4-1.8c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2c0.5-0.3,1.1-0.4,1.7-0.4 c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.1,1.1C107.8,28.2,107.9,28.8,107.9,29.4z M106.2,29.2c0-0.5-0.1-1-0.4-1.2 c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.2,0.4c-0.3,0.3-0.5,0.7-0.5,1.2H106.2z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M115.3,31.5V33h-0.9c-0.7,0-1.3-0.2-1.7-0.5c-0.4-0.4-0.6-1-0.6-1.8v-2.9h-0.9v-1.4h0.9v-1.6h1.7v1.6h1.5v1.4h-1.5v2.9 c0,0.3,0.1,0.5,0.2,0.7c0.1,0.1,0.3,0.2,0.6,0.2H115.3z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M120.5,26.2c0.8,0,1.4,0.3,1.8,0.8c0.5,0.5,0.7,1.2,0.7,2.1V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4 c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.8-0.4,1.3V33h-1.7v-8.9h1.7v3.6c0.2-0.4,0.5-0.8,0.9-1C119.5,26.4,119.9,26.2,120.5,26.2z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M130.7,29.4c0,0.2,0,0.4-0.1,0.6h-4.9c0,0.6,0.2,1,0.5,1.3c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,1-0.3 c0.3-0.2,0.4-0.5,0.5-0.8h1.8c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.5,0.3c-0.6,0-1.2-0.1-1.7-0.4 c-0.5-0.3-0.9-0.7-1.2-1.2s-0.4-1.1-0.4-1.8c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2c0.5-0.3,1.1-0.4,1.7-0.4 c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.1,1.1C130.6,28.2,130.7,28.8,130.7,29.4z M129,29.2c0-0.5-0.1-1-0.4-1.2 c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.2,0.4c-0.3,0.3-0.5,0.7-0.5,1.2H129z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M138.5,26.2c0.8,0,1.4,0.3,1.8,0.8s0.7,1.2,0.7,2.1V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4 c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.4,0.8-0.4,1.3V33h-1.7v-8.9h1.7v3.6c0.2-0.4,0.5-0.8,0.9-1C137.5,26.4,138,26.2,138.5,26.2z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M145.6,26.2c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.3-0.4,1.8 c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1.1,0.4-1.7,0.4c-0.6,0-1.2-0.1-1.8-0.4c-0.5-0.3-0.9-0.7-1.2-1.2s-0.4-1.1-0.4-1.8 c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2C144.3,26.4,144.9,26.2,145.6,26.2z M145.6,27.7c-0.5,0-0.9,0.2-1.2,0.5 c-0.3,0.3-0.5,0.8-0.5,1.4s0.2,1.1,0.5,1.5c0.3,0.3,0.7,0.5,1.2,0.5s0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.8,0.5-1.5s-0.2-1.1-0.5-1.4 C146.4,27.9,146.1,27.7,145.6,27.7z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M158.6,26.2c0.8,0,1.4,0.3,1.9,0.8c0.5,0.5,0.7,1.2,0.7,2.1V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4 c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.3V33h-1.7v-3.7c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.4-1.1-0.4 c-0.5,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.3V33h-1.7v-6.6h1.7v1.3c0.2-0.4,0.5-0.8,0.8-1c0.4-0.2,0.8-0.4,1.3-0.4 c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.7,0.6,0.9,1.1c0.2-0.5,0.5-0.8,0.9-1.1C157.7,26.4,158.1,26.2,158.6,26.2z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M169,29.4c0,0.2,0,0.4-0.1,0.6h-4.9c0,0.6,0.2,1,0.5,1.3s0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.4-0.5,0.5-0.8h1.8 c-0.1,0.5-0.3,0.9-0.6,1.2c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.5,0.3c-0.6,0-1.2-0.1-1.7-0.4c-0.5-0.3-0.9-0.7-1.2-1.2 s-0.4-1.1-0.4-1.8c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2s1.1-0.4,1.7-0.4c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.1,1.1 C168.9,28.2,169,28.8,169,29.4z M167.3,29.2c0-0.5-0.1-1-0.4-1.2c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.2,0.4 c-0.3,0.3-0.5,0.7-0.5,1.2H167.3z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M179.7,26.3l-1.8,6.6h-1.9l-1.4-4.8l-1.5,4.8h-1.9l-1.8-6.6h1.7l1.1,5.1l1.5-5.1h1.8l1.5,5.1l1.1-5.1H179.7z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M183.6,26.2c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.3-0.4,1.8 s-0.7,0.9-1.2,1.2c-0.5,0.3-1.1,0.4-1.7,0.4s-1.2-0.1-1.8-0.4c-0.5-0.3-0.9-0.7-1.2-1.2c-0.3-0.5-0.4-1.1-0.4-1.8 c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.2C182.4,26.4,183,26.2,183.6,26.2z M183.6,27.7c-0.5,0-0.9,0.2-1.2,0.5 c-0.3,0.3-0.5,0.8-0.5,1.4s0.2,1.1,0.5,1.5c0.3,0.3,0.7,0.5,1.2,0.5s0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.8,0.5-1.5s-0.2-1.1-0.5-1.4 C184.5,27.9,184.1,27.7,183.6,27.7z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M189.9,27.6c0.2-0.4,0.6-0.8,1-1c0.4-0.2,0.9-0.4,1.4-0.4V28h-0.5c-1.2,0-1.9,0.6-1.9,1.7V33h-1.7v-6.6h1.7V27.6z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M197.1,33l-2.2-2.9V33h-1.7v-8.9h1.7v5l2.2-2.8h2l-2.8,3.3l2.9,3.3H197.1z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M50,52.4V55h-1.4v-7.1h2.6c0.8,0,1.5,0.2,1.9,0.6c0.4,0.4,0.6,0.9,0.6,1.6c0,0.7-0.2,1.2-0.7,1.6 c-0.4,0.4-1.1,0.6-1.9,0.6H50z M51.1,51.2c0.8,0,1.2-0.4,1.2-1.1c0-0.4-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.9-0.3h-1v2.2H51.1z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M56.1,50.5c0.2-0.4,0.5-0.6,0.8-0.8c0.3-0.2,0.7-0.3,1.1-0.3v1.5h-0.4c-1,0-1.5,0.5-1.5,1.4V55h-1.4v-5.5h1.4 V50.5z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M61.4,49.4c0.5,0,1,0.1,1.5,0.3c0.4,0.2,0.8,0.6,1,1c0.2,0.4,0.4,0.9,0.4,1.5c0,0.6-0.1,1.1-0.4,1.5 c-0.2,0.4-0.6,0.8-1,1c-0.4,0.2-0.9,0.3-1.5,0.3s-1-0.1-1.5-0.3c-0.4-0.2-0.8-0.6-1-1c-0.2-0.4-0.4-0.9-0.4-1.5 c0-0.6,0.1-1.1,0.4-1.5c0.2-0.4,0.6-0.8,1-1C60.3,49.5,60.8,49.4,61.4,49.4z M61.4,50.6c-0.4,0-0.7,0.1-1,0.4 c-0.3,0.3-0.4,0.7-0.4,1.2c0,0.5,0.1,0.9,0.4,1.2c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.7,0.4-1.2 c0-0.5-0.1-0.9-0.4-1.2C62.1,50.7,61.7,50.6,61.4,50.6z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M67.4,49.4c0.5,0,0.9,0.1,1.2,0.3c0.3,0.2,0.6,0.5,0.7,0.9v-1.2h1.4V55c0,0.5-0.1,1-0.3,1.4 c-0.2,0.4-0.5,0.7-0.9,1c-0.4,0.2-0.9,0.4-1.5,0.4c-0.8,0-1.4-0.2-1.9-0.6c-0.5-0.4-0.8-0.9-0.9-1.6h1.4c0.1,0.3,0.2,0.5,0.5,0.7 c0.2,0.2,0.5,0.2,0.9,0.2c0.4,0,0.7-0.1,1-0.4c0.3-0.2,0.4-0.6,0.4-1.1v-1.2c-0.1,0.4-0.4,0.7-0.7,0.9c-0.3,0.2-0.7,0.3-1.2,0.3 c-0.5,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.7-0.6-0.9-1c-0.2-0.4-0.3-0.9-0.3-1.5c0-0.6,0.1-1.1,0.3-1.5c0.2-0.4,0.5-0.8,0.9-1 C66.5,49.5,66.9,49.4,67.4,49.4z M67.8,50.6c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.2s0.1,0.9,0.4,1.2 c0.3,0.3,0.6,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.2c0-0.5-0.1-0.9-0.4-1.2C68.6,50.7,68.2,50.6,67.8,50.6z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M73.4,50.5c0.2-0.4,0.5-0.6,0.8-0.8c0.3-0.2,0.7-0.3,1.1-0.3v1.5h-0.4c-1,0-1.5,0.5-1.5,1.4V55H72v-5.5h1.4 V50.5z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M81.3,52c0,0.1,0,0.3,0,0.5h-4.1c0,0.5,0.2,0.9,0.4,1.1c0.2,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.8-0.2 c0.2-0.2,0.4-0.4,0.4-0.7h1.5c-0.1,0.4-0.2,0.7-0.5,1c-0.2,0.3-0.6,0.5-0.9,0.7C79.5,55,79.1,55,78.6,55c-0.5,0-1-0.1-1.4-0.3 c-0.4-0.2-0.7-0.6-1-1c-0.2-0.4-0.3-0.9-0.3-1.5c0-0.6,0.1-1.1,0.3-1.5c0.2-0.4,0.6-0.8,1-1c0.4-0.2,0.9-0.3,1.4-0.3 c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9C81.2,51,81.3,51.5,81.3,52z M79.9,51.9c0-0.5-0.1-0.8-0.4-1 c-0.3-0.2-0.6-0.3-0.9-0.3c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.4,0.6-0.4,1H79.9z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M84.2,49.4c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.7,0.8,0.8,1.4h-1.3c-0.1-0.3-0.2-0.5-0.4-0.6s-0.4-0.2-0.7-0.2 c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.4,0.1,0.7,0.2 c0.4,0.1,0.8,0.2,1,0.3c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.3,0.9c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-0.9,0.4-1.5,0.4 c-0.7,0-1.3-0.2-1.7-0.5c-0.4-0.3-0.7-0.8-0.8-1.4h1.3c0,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2-0.1-0.4-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1-0.3 c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.5,0.2-0.9,0.5-1.2C83.1,49.5,83.6,49.4,84.2,49.4z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M89.6,49.4c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.7,0.8,0.8,1.4h-1.3c-0.1-0.3-0.2-0.5-0.4-0.6 c-0.2-0.2-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0.1,0.4,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1,0.3c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.3,0.9c0,0.5-0.2,0.9-0.6,1.2 C91.2,54.9,90.7,55,90,55c-0.7,0-1.3-0.2-1.7-0.5c-0.4-0.3-0.7-0.8-0.8-1.4h1.3c0,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.5,0.2,0.8,0.2 c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.4-0.1-0.8-0.2-1-0.3c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.5,0.2-0.9,0.6-1.2C88.5,49.5,89,49.4,89.6,49.4z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M97.4,51.7c0,2.2,0.8,3.2,2.4,3.2c0.9,0,1.5-0.3,1.9-0.9s0.6-1.4,0.6-2.4c0-1-0.2-1.8-0.6-2.4s-1-0.9-1.9-0.9 C98.2,48.5,97.4,49.6,97.4,51.7z M101,51.7c0,0.7-0.1,1.2-0.2,1.5c-0.2,0.3-0.5,0.5-0.9,0.5c-0.5,0-0.8-0.2-0.9-0.5 c-0.2-0.4-0.2-0.9-0.2-1.5c0-0.6,0.1-1.1,0.2-1.5c0.2-0.4,0.5-0.5,0.9-0.5c0.5,0,0.8,0.2,0.9,0.5C100.9,50.6,101,51.1,101,51.7z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M106.3,46.4l-2.4,10.2h-1.2l2.4-10.2H106.3z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M106.2,49.8v-1.2h2.3V55h-1.3v-5.2H106.2z"
});

var SvgGoal2 = function SvgGoal2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328 80",
    style: {
      enableBackground: "new 0 0 328 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5)), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoal2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goal-2.687c18dc.svg";
export { ForwardRef as ReactComponent };